export const ideas = {
  // Page Header
  'ideasProjects': 'Ideas y Proyectos',
  'captureOrganizeEvolve': 'Captura, organiza y evoluciona tus ideas de proyecto',
  
  // Stats Cards
  'totalIdeas': 'Total Ideas',
  'thisWeek': 'Esta Semana',
  'ready': 'Listas',
  'archived': 'Archivadas',
  
  // Search and Filters
  'searchIdeas': 'Buscar ideas...',
  'kanban': 'Kanban',
  'grid': 'Cuadrícula',
  'all': 'Todas',
  
  // Tabs
  'activeIdeas': 'Ideas Activas',
  'recentIdeas': 'Recientes',
  'archivedIdeas': 'Archivadas',
  
  // Empty States
  'noIdeas': 'No hay ideas',
  'noIdeasFiltered': 'No se encontraron ideas con los filtros actuales',
  'startCreating': 'Comienza creando tu primera idea',
  
  // Actions
  'confirmDelete': '¿Estás seguro de que quieres eliminar esta idea?',
  
  // Kanban Columns
  'ideasColumn': 'Ideas',
  'exploringColumn': 'Explorando',
  'planningColumn': 'Planificando',
  'readyColumn': 'Listas',
  'dragIdeasHere': 'Arrastra ideas aquí',
  
  // Create Dialog
  'newIdea': 'Nueva Idea',
  'addIdeaBtn': '+ Nueva Idea',
  'title': 'Título',
  'titlePlaceholder': '¿Cuál es tu idea?',
  'description': 'Descripción',
  'descriptionPlaceholder': 'Describe tu idea con más detalle...',
  'category': 'Categoría',
  'priority': 'Prioridad',
  'tags': 'Etiquetas',
  'addTag': 'Añadir etiqueta',
  'tagPlaceholder': 'Añadir etiqueta...',
  'estimatedEffort': 'Esfuerzo Estimado',
  'potentialImpact': 'Impacto Potencial',
  'feasibility': 'Factibilidad',
  'cancel': 'Cancelar',
  'create': 'Crear Idea',
  'creating': 'Creando...',
  'veryLow': 'Muy baja',
  'low': 'Baja',
  'medium': 'Media',
  'high': 'Alta',
  'veryHigh': 'Muy alta',
  'easy': 'Fácil',
  'possible': 'Posible',
  'difficult': 'Difícil'
};